module.exports = __webpack_public_path__ + "img/sweet_potato.61ee6470.png";